enum table {
    'empty' = 'No data available',
}

export default table;
